import { ref } from 'vue'

/**
 * Module-level shared state (singleton pattern).
 * Tab indices: 0 = Události (events/home), 1 = Týmy (teams), 2 = Organizace (leagues)
 */
const activeTab = ref(0)

export const TAB_PATHS = ['/', '/teams', '/leagues'] as const

export const MAIN_ROUTES = new Set(['/', '/teams', '/leagues'])

/**
 * Composable for mobile tab navigation.
 * Manages shared tab state between MobileHomeView and MobileBottomNav.
 * Uses Vuetify's v-window for smooth slide-in/slide-out transitions.
 */
export function useNavTransition() {
  /**
   * Switch to a specific tab by index.
   * Does nothing if the index is out of range or already active.
   */
  function setTab(index: number) {
    if (index < 0 || index > 2 || index === activeTab.value) return
    activeTab.value = index
  }

  /**
   * Initialize the active tab from a route path (used on mount and route sync).
   * Only updates if the resolved tab differs from the current one
   * to prevent unnecessary v-window animations.
   */
  function initFromPath(path: string) {
    let newTab = 0
    if (path === '/teams' || path.startsWith('/teams')) newTab = 1
    else if (path === '/leagues' || path.startsWith('/leagues')) newTab = 2

    if (activeTab.value !== newTab) {
      activeTab.value = newTab
    }
  }

  /**
   * Check if a given path is one of the 3 main mobile tab routes.
   */
  function isMainRoute(path: string): boolean {
    return MAIN_ROUTES.has(path)
  }

  return {
    activeTab,
    setTab,
    initFromPath,
    isMainRoute,
    TAB_PATHS,
  }
}
